import React, { FC } from 'react';
import { IIconSvg } from '../../../ui/IconSvg/types';

const IconSvgSettings: FC<IIconSvg> = ({ name, w, h, color }) => {
  switch (name) {
    case 'appearance':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='21'
          fill='none'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M1.875 2.403c0-.345.28-.625.625-.625h11.667c.345 0 .625.28.625.625v6.25c0 .345-.28.625-.625.625H2.5a.625.625 0 0 1-.625-.625v-6.25Zm1.25.625v5h10.417v-5H3.125Z'
            clipRule='evenodd'
          />
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M13.552 5.32c0-.345.28-.625.625-.625h3.74c.345 0 .625.28.625.625v6.709c0 .314-.234.58-.545.62l-9.455 1.22v4.368a.625.625 0 0 1-1.25 0V13.32c0-.314.233-.58.545-.62l9.455-1.22V5.944h-3.115a.625.625 0 0 1-.625-.625Z'
            clipRule='evenodd'
          />
        </svg>
      );
    case 'chat-bot':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='21'
          fill='none'
        >
          <g clipPath='url(#a)'>
            <path
              fill='#fff'
              fillRule='evenodd'
              d='M20 10.32c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10ZM10 4.606c-2.972 0-4.643.62-5.693 1.16C2.571 6.733.714 8.102.714 10.63s1.575 4.61 3.593 4.863c1.227.268 3.898.541 5.693.541 1.787 0 4.377-.27 5.664-.537 2.032-.238 3.622-2.326 3.622-4.867 0-2.54-2.136-4.164-3.622-4.867-1.207-.537-2.6-1.157-5.664-1.157Zm0 1.428c-2.286 0-3.571.465-4.379.871-1.335.724-2.764 1.751-2.764 3.648 0 1.896 1.211 3.457 2.764 3.647.944.201 2.999.406 4.38.406 1.374 0 3.366-.203 4.356-.403 1.563-.178 2.786-1.745 2.786-3.65 0-1.906-1.643-3.123-2.786-3.65-.928-.404-2-.869-4.357-.869ZM5.87 12.101c.888.24 1.835-.408 2.114-1.445.279-1.037-.216-2.071-1.104-2.31-.89-.24-1.836.407-2.115 1.444-.279 1.038.216 2.072 1.105 2.311Zm8.13.03c.888-.239 1.383-1.273 1.104-2.31-.28-1.037-1.226-1.684-2.115-1.445-.889.239-1.383 1.273-1.104 2.31.278 1.037 1.225 1.684 2.114 1.445Z'
              clipRule='evenodd'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M0 .32h20v20H0z' />
            </clipPath>
          </defs>
        </svg>
      );
    case 'logo-panda':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='18'
          fill='none'
        >
          <g fill='#fff' fillRule='evenodd' clipRule='evenodd'>
            <path d='M11.329.705a.407.407 0 1 0-.813-.036c-.014.337-.115.609-.275.808a1.07 1.07 0 0 1-.25.227c.018-.133.018-.27-.003-.406a.407.407 0 0 0-.804.128.672.672 0 0 1-.114.463.433.433 0 0 1-.207.176A9.716 9.716 0 0 0 5.045 3.34a2.068 2.068 0 0 0-.833-.88c-1.2-.67-2.863.023-3.716 1.549-.852 1.525-.57 3.305.63 3.975.054.03.109.058.164.082a7.15 7.15 0 0 0-.264 1.929c0 4.42 4.047 8.001 9.038 8.001 4.992 0 9.038-3.582 9.038-8.001 0-.71-.104-1.399-.3-2.055.022-.01.044-.023.066-.035 1.203-.665 1.493-2.443.648-3.972-.845-1.53-2.505-2.23-3.708-1.566-.373.207-.659.52-.85.9a9.63 9.63 0 0 0-2.739-1.045c.111-.123.207-.27.273-.449a.407.407 0 0 0-.763-.282c-.063.17-.204.296-.39.385a1.187 1.187 0 0 1-.471.12l.005-.008.003-.003c.285-.355.432-.801.453-1.281Zm-2.305 2.16c-.07.016-.142.025-.218.026-4.013.534-6.966 3.585-6.966 7.105 0 3.88 3.586 7.188 8.224 7.188s8.224-3.309 8.224-7.188c0-3.88-3.586-7.188-8.224-7.188-.353 0-.7.02-1.04.056Z' />
            <path d='M5.63 11.937c1.078.36 2.361-.575 2.866-2.087.504-1.513.039-3.03-1.04-3.39-1.078-.36-2.361.575-2.866 2.087-.504 1.513-.039 3.03 1.04 3.39Zm8.774.01c-1.065.354-2.338-.585-2.843-2.097-.505-1.513-.052-3.026 1.013-3.38 1.064-.355 2.337.584 2.842 2.096.505 1.513.052 3.026-1.013 3.38Zm-4.597.389c-.36-.105-1.304-.378-1.182-1.038.148-.803 1.666-.927 2.424-.646.76.281.831 1.432-1.107 1.73a.577.577 0 0 0-.135-.046Zm-.729 1.05a.407.407 0 1 0-.716.387c.178.329.732.924 1.637.924s1.459-.595 1.636-.924a.407.407 0 0 0-.716-.387 1.084 1.084 0 0 1-.92.497c-.527 0-.843-.352-.92-.497Zm3.356-3.247c0 .504.37.912.829.912.458 0 .829-.408.829-.912 0-.503-.371-.912-.83-.912-.457 0-.829.409-.829.912Zm-4.828.012c0 .504-.37.912-.829.912-.458 0-.829-.408-.829-.912 0-.503.371-.912.83-.912.457 0 .828.409.828.912Z' />
          </g>
        </svg>
      );

    case 'ai-bot':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '18'}
          height={h || '19'}
          fill='none'
          viewBox='0 0 18 19'
        >
          <g fill='#fff' clipPath='url(#a-ai-bot)'>
            <mask id='b-ai-bot'>
              <path
                fillRule='evenodd'
                d='M.094 18.296V9.308C.094 4.344 4.08.32 8.998.32c4.918 0 8.905 4.024 8.905 8.988 0 4.964-3.987 8.988-8.905 8.988H.094Zm9.13-6.94.602 1.92h1.76l-.017-.047a1.651 1.651 0 0 0 1.262-1.604V7.67a1.65 1.65 0 0 0-1.65 1.65v2.79L8.833 5.365H6.888l-2.746 7.91h1.7l.602-1.918h2.78ZM6.8 10.119l1.014-3.24h.038l1.014 3.24H6.8Zm6.03-3.928a.825.825 0 1 1-1.65 0 .825.825 0 0 1 1.65 0Z'
                clipRule='evenodd'
              />
            </mask>
            <path
              fillRule='evenodd'
              d='M.094 18.296V9.308C.094 4.344 4.08.32 8.998.32c4.918 0 8.905 4.024 8.905 8.988 0 4.964-3.987 8.988-8.905 8.988H.094Zm9.13-6.94.602 1.92h1.76l-.017-.047a1.651 1.651 0 0 0 1.262-1.604V7.67a1.65 1.65 0 0 0-1.65 1.65v2.79L8.833 5.365H6.888l-2.746 7.91h1.7l.602-1.918h2.78ZM6.8 10.119l1.014-3.24h.038l1.014 3.24H6.8Zm6.03-3.928a.825.825 0 1 1-1.65 0 .825.825 0 0 1 1.65 0Z'
              clipRule='evenodd'
            />
            <path
              d='M.094 18.296h-7.969v7.969H.094v-7.969Zm9.732-5.02-7.602 2.388 1.753 5.58h5.849v-7.969Zm-.603-1.92 7.602-2.388-1.753-5.58H9.223v7.969Zm2.362 1.92v7.968h11.21l-3.683-10.587-7.527 2.618Zm-.016-.047L9.698 5.483 1.156 7.547l2.887 8.3 7.526-2.618Zm1.262-5.56H20.8V-.298h-7.97V7.67Zm-1.65 4.441L3.653 14.73l15.495-2.619H11.18ZM8.833 5.365l7.526-2.618-1.86-5.35H8.833v7.968Zm-1.946 0v-7.969H1.22L-.64 2.752l7.528 2.613Zm-2.746 7.91-7.528-2.613-3.673 10.582H4.142v-7.969Zm1.7 0v7.969h5.848l1.754-5.58-7.603-2.389Zm.602-1.918v-7.97H.595l-1.753 5.58 7.602 2.39Zm1.37-4.479v-7.969H1.96L.209 4.498l7.606 2.38Zm-1.013 3.24-7.605-2.38-3.24 10.348H6.801v-7.968Zm1.052-3.24 7.605-2.38-1.75-5.589H7.854v7.969Zm1.014 3.24v7.968H19.71l-3.24-10.349-7.604 2.38Zm-16.742-.81v8.988H8.063V9.308H-7.876ZM8.998-7.649C-.39-7.649-7.875.013-7.875 9.308H8.063c0-.633.488-1.02.935-1.02V-7.648ZM25.872 9.308c0-9.295-7.485-16.957-16.874-16.957V8.29c.447 0 .936.386.936 1.02h15.938ZM8.998 26.265c9.39 0 16.874-7.662 16.874-16.957H9.934c0 .633-.489 1.02-.936 1.02v15.937Zm-8.904 0h8.904V10.327H.094v15.938Zm17.334-15.379-.603-1.918-15.204 4.777.603 1.92 15.204-4.779Zm-5.843-5.58H9.826v15.938h1.76V5.306ZM4.043 15.847l.016.046 15.053-5.236-.016-.046-15.053 5.236Zm.82-4.222a6.318 6.318 0 0 1 4.835-6.142l3.743 15.492c4.218-1.02 7.359-4.809 7.359-9.35H4.862Zm0-3.955v3.955H20.8V7.67H4.862Zm14.286 1.65a6.318 6.318 0 0 1-6.318 6.318V-.299a9.62 9.62 0 0 0-9.62 9.62H19.15Zm0 2.79V9.32H3.212v2.79h15.937ZM1.308 7.983l2.346 6.746 15.053-5.237-2.347-6.745L1.308 7.983Zm5.58 5.35h1.946V-2.603H6.888v15.938Zm4.782 2.555 2.746-7.91L-.64 2.752l-2.746 7.91 15.056 5.226ZM5.841 5.306H4.142v15.938h1.7V5.306Zm-6.999 3.662-.603 1.918 15.205 4.778.602-1.918-15.204-4.778Zm10.381-5.58H6.444v15.937h2.78V3.388ZM.21 4.498l-1.014 3.24 15.21 4.76 1.013-3.24L.21 4.498Zm7.643-5.589h-.038v15.938h.038V-1.091Zm8.619 8.828-1.014-3.24L.248 9.259l1.014 3.24 15.21-4.76ZM6.8 18.087h2.066V2.148H6.8v15.937Zm5.205-3.103A8.794 8.794 0 0 0 20.8 6.19H4.862a7.143 7.143 0 0 1 7.144-7.143v15.937ZM3.212 6.19a8.794 8.794 0 0 0 8.794 8.794V-.953a7.144 7.144 0 0 1 7.143 7.143H3.212Zm8.794-8.794A8.794 8.794 0 0 0 3.212 6.19h15.937a7.143 7.143 0 0 1-7.143 7.144V-2.604ZM20.8 6.19a8.794 8.794 0 0 0-8.794-8.794v15.938A7.144 7.144 0 0 1 4.862 6.19H20.8Z'
              mask='url(#b-ai-bot)'
            />
          </g>
          <defs>
            <clipPath id='a-ai-bot'>
              <path fill='#fff' d='M0 .32h18v18H0z' />
            </clipPath>
          </defs>
        </svg>
      );
    case 'cloud':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={h || '20'}
          height={w || '21'}
          fill='none'
          viewBox='0 0 20 21'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M15 8.653h-1.05a6.667 6.667 0 1 0-6.45 8.334H15a4.167 4.167 0 0 0 0-8.334Z'
          />
        </svg>
      );
    case 'wallet':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='21'
          fill='none'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M18.333 10.32v4.167c0 2.5-1.667 4.166-4.167 4.166H5.833c-2.5 0-4.167-1.666-4.167-4.166V10.32c0-2.267 1.367-3.85 3.492-4.117.216-.033.441-.05.675-.05h8.333c.217 0 .425.009.625.042 2.15.25 3.542 1.842 3.542 4.125Z'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M14.793 6.195a3.81 3.81 0 0 0-.624-.042H5.835c-.233 0-.458.017-.675.05.117-.233.283-.45.483-.65l2.709-2.716a2.937 2.937 0 0 1 4.133 0l1.459 1.475c.533.525.816 1.191.85 1.883ZM18.333 10.737h-2.5c-.917 0-1.667.75-1.667 1.666 0 .917.75 1.667 1.667 1.667h2.5'
          />
        </svg>
      );
    case 'shopping-cart':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='21'
          fill='none'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeWidth='1.5'
            d='M1.666 1.987h1.45c.9 0 1.608.775 1.533 1.666l-.691 8.3a2.33 2.33 0 0 0 2.325 2.526h8.875c1.2 0 2.25-.984 2.341-2.175l.45-6.25c.1-1.384-.95-2.509-2.341-2.509H4.849M13.542 18.653a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM6.876 18.653a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM7.5 6.987h10'
          />
        </svg>
      );
    case 'setting':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          width='20'
          height='21'
          viewBox='0 0 20 21'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M2.5 7.912v4.808c0 1.767 0 1.767 1.667 2.892l4.583 2.65c.692.4 1.817.4 2.5 0l4.583-2.65c1.667-1.125 1.667-1.125 1.667-2.884V7.912c0-1.759 0-1.759-1.667-2.884l-4.583-2.65c-.683-.4-1.808-.4-2.5 0l-4.583 2.65C2.5 6.153 2.5 6.153 2.5 7.912Z'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M10 12.82a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z'
          />
        </svg>
      );
    case 'circle-line':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          width='24'
          height='25'
          viewBox='0 0 24 25'
        >
          <path
            stroke='#0A49A5'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeWidth='1.5'
            d='M12 22.5c5.52 0 10-4.48 10-10s-4.48-10-10-10-10 4.48-10 10 4.48 10 10 10ZM18.9 5.5l-14 14'
          />
        </svg>
      );
    case 'sms':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          width='24'
          height='25'
          viewBox='0 0 24 25'
        >
          <path
            stroke='#0A49A5'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeWidth='1.5'
            d='M17 21H7c-3 0-5-1.5-5-5V9c0-3.5 2-5 5-5h10c3 0 5 1.5 5 5v7c0 3.5-2 5-5 5Z'
          />
          <path
            stroke='#0A49A5'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeWidth='1.5'
            d='M17 9.5 13.87 12c-1.03.82-2.72.82-3.75 0L7 9.5'
          />
        </svg>
      );
    case 'password-check':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          width='24'
          height='25'
          viewBox='0 0 24 25'
        >
          <path
            stroke='#0A49A5'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M11.02 20H7.5c-.62 0-1.17-.02-1.66-.09C3.21 19.62 2.5 18.38 2.5 15v-5c0-3.38.71-4.62 3.34-4.91C6.33 5.02 6.88 5 7.5 5h3.46M15.02 5h1.48c.62 0 1.17.02 1.66.09 2.63.29 3.34 1.53 3.34 4.91v5c0 3.38-.71 4.62-3.34 4.91-.49.07-1.04.09-1.66.09h-1.48M15 2.5v20'
          />
          <path
            stroke='#0A49A5'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M11.094 12.5h.01M7.094 12.5h.01'
          />
        </svg>
      );
    case 'question-mark':
      return (
        <svg
          width='32'
          height='32'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='32' height='32' rx='12' fill='#619DF5' />
          <path
            d='M16 24.3332C20.5834 24.3332 24.3334 20.5832 24.3334 15.9998C24.3334 11.4165 20.5834 7.6665 16 7.6665C11.4167 7.6665 7.66669 11.4165 7.66669 15.9998C7.66669 20.5832 11.4167 24.3332 16 24.3332Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.5 13.5C13.6959 12.943 14.0826 12.4734 14.5916 12.1743C15.1006 11.8751 15.6991 11.7658 16.281 11.8656C16.8629 11.9654 17.3907 12.2679 17.7709 12.7196C18.1511 13.1713 18.3592 13.7429 18.3583 14.3333C18.3583 16 15.8583 16.8333 15.8583 16.8333'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.9249 20.1665H15.9333'
            stroke='white'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'device':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          fill='none'
        >
          <g
            stroke='#0A49A5'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
          >
            <path d='M10 17.45H6.21c-3.37 0-4.21-.84-4.21-4.21v-6c0-3.37.84-4.21 4.21-4.21h10.53c3.37 0 4.21.84 4.21 4.21M10 21.97v-4.52M2 13.45h8M6.74 21.97H10' />
            <path d='M22 13.3v5.71c0 2.37-.59 2.96-2.96 2.96h-3.55c-2.37 0-2.96-.59-2.96-2.96V13.3c0-2.37.59-2.96 2.96-2.96h3.55c2.37 0 2.96.59 2.96 2.96ZM17.244 18.75h.01' />
          </g>
        </svg>
      );
    case 'stop':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          fill='none'
        >
          <g
            stroke='#EF4062'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
          >
            <path d='M14.9 2.5H9.1c-.68 0-1.64.4-2.12.88l-4.1 4.1C2.4 7.96 2 8.92 2 9.6v5.8c0 .68.4 1.64.88 2.12l4.1 4.1c.48.48 1.44.88 2.12.88h5.8c.68 0 1.64-.4 2.12-.88l4.1-4.1c.48-.48.88-1.44.88-2.12V9.6c0-.68-.4-1.64-.88-2.12l-4.1-4.1c-.48-.48-1.44-.88-2.12-.88ZM4.94 19.58 19.08 5.44' />
          </g>
        </svg>
      );
    case 'ello-coin':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          fill='none'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M1.912 2.642A4.82 4.82 0 0 1 5.32 1.23h13.36a4.82 4.82 0 0 1 4.82 4.82v9.54a4.82 4.82 0 0 1-4.82 4.82h-3.406L12 23.684 8.726 20.41H5.32A4.82 4.82 0 0 1 .5 15.59V6.05a4.82 4.82 0 0 1 1.412-3.408Zm3.408.588A2.82 2.82 0 0 0 2.5 6.05v9.54a2.82 2.82 0 0 0 2.82 2.82h4.234L12 20.856l2.446-2.446h4.234a2.82 2.82 0 0 0 2.82-2.82V6.05a2.82 2.82 0 0 0-2.82-2.82H5.32Z'
            clipRule='evenodd'
          />
          <path
            fill='#fff'
            d='M7 16V6h.988c.535.04 1.605.386 1.605 1.446v2.53h3.21v1.807h-3.21v2.169H17V16H7Z'
          />
          <path
            fill='#fff'
            d='M16.877 6H11.69c-.329 0-.987.169-.987.843V8.29h5.185c.33 0 .988-.169.988-.843V6Z'
          />
        </svg>
      );

    case 'paypal':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          fill='none'
        >
          <g stroke='#070708' strokeMiterlimit='10' strokeWidth='1.5'>
            <path d='M19 7v.5c-.1 1.5-.8 2.8-1.7 3.7-1.1 1.1-2.6 1.8-4.3 1.8H9.9c-.5 0-.9.4-1 .9l-.8 5.3c-.1.4-.3.7-.7.8H5.2c-.6 0-1.1-.5-1-1.2L6.6 4.5C6.8 3.1 8.1 2 9.5 2H14c2.8 0 5 2.2 5 5Z' />
            <path d='M21 11c0 1.4-.6 2.6-1.5 3.5-.9.9-2.1 1.5-3.5 1.5h-2.1c-.5 0-.9.3-1 .8l-.7 4.3c-.1.5-.5.8-1 .8h-3c-.6 0-1.1-.6-1-1.2l.2-.7c.4-.1.7-.4.7-.8l.8-5.3c.1-.5.5-.9 1-.9H13c1.7 0 3.2-.7 4.2-1.8 1-1 1.6-2.3 1.7-3.7 1.3.7 2.1 2 2.1 3.5Z' />
          </g>
        </svg>
      );
    case 'payment-methods':
      return (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.33398 8.50488H22.334'
            stroke='#070708'
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6.33398 16.5049H8.33398'
            stroke='#070708'
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.834 16.5049H14.834'
            stroke='#070708'
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6.77398 3.50488H17.884C21.444 3.50488 22.334 4.38488 22.334 7.89488V16.1049C22.334 19.6149 21.444 20.4949 17.894 20.4949H6.77398C3.22398 20.5049 2.33398 19.6249 2.33398 16.1149V7.89488C2.33398 4.38488 3.22398 3.50488 6.77398 3.50488Z'
            stroke='#070708'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'balance':
      return (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M22.666 12V17C22.666 20 20.666 22 17.666 22H7.66602C4.66602 22 2.66602 20 2.66602 17V12C2.66602 9.28 4.30602 7.38 6.85602 7.06C7.11602 7.02 7.38602 7 7.66602 7H17.666C17.926 7 18.176 7.00999 18.416 7.04999C20.996 7.34999 22.666 9.26 22.666 12Z'
            stroke='#070708'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18.4174 7.05C18.1774 7.01 17.9274 7.00001 17.6674 7.00001H7.66742C7.38742 7.00001 7.11742 7.02001 6.85742 7.06001C6.99742 6.78001 7.19742 6.52001 7.43742 6.28001L10.6874 3.02C12.0574 1.66 14.2774 1.66 15.6474 3.02L17.3974 4.79002C18.0374 5.42002 18.3774 6.22 18.4174 7.05Z'
            stroke='#070708'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M22.666 12.5H19.666C18.566 12.5 17.666 13.4 17.666 14.5C17.666 15.6 18.566 16.5 19.666 16.5H22.666'
            stroke='#070708'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'stripe':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          fill='none'
        >
          <path
            fill='#000'
            d='M12.43 7.894c-.406 0-.724.334-.724.759 0 .422.318.76.723.76.402 0 .724-.338.724-.76 0-.425-.322-.76-.724-.76Zm-4.661.675-1.179.196-.16 1.097-.43.085-.16 1.012h.59v2.11c0 .548.13.92.401 1.153.228.193.556.28 1.018.28.355 0 .573-.07.723-.112v-1.125a1.8 1.8 0 0 1-.402.057c-.27 0-.401-.144-.401-.478v-1.885h.723l.16-1.097H7.77V8.57ZM4.206 9.778c-.469 0-.874.126-1.152.366-.29.25-.428.629-.428 1.068 0 .795.452 1.122 1.205 1.407.486.179.643.305.643.506 0 .193-.144.31-.429.31-.351 0-.934-.187-1.312-.423l-.16 1.097c.324.194.93.394 1.553.394.495 0 .9-.102 1.178-.338.312-.256.483-.66.483-1.153 0-.812-.47-1.15-1.233-1.434-.405-.158-.642-.257-.642-.45 0-.165.12-.281.348-.281.418 0 .857.186 1.152.337l.16-1.097a3.05 3.05 0 0 0-1.366-.31Zm11.84 0c-.402 0-.77.193-1.099.562l-.053-.478h-1.232v6.244l1.392-.253v-1.434c.211.07.422.084.617.084.344 0 .843-.091 1.232-.534.371-.426.562-1.07.562-1.941 0-.77-.124-1.371-.402-1.744-.244-.334-.582-.506-1.017-.506Zm3.616 0c-1.176 0-1.902.928-1.902 2.39 0 .82.177 1.438.562 1.829.345.351.86.506 1.5.506.59 0 1.129-.127 1.474-.366l-.161-1.012c-.338.193-.734.31-1.179.31-.268 0-.455-.075-.59-.198-.143-.13-.213-.32-.24-.618h2.277c.006-.07.026-.401.026-.507 0-.724-.16-1.311-.455-1.715-.301-.408-.74-.62-1.312-.62Zm-8.518.028a.851.851 0 0 0-.83.619l-.081-.563H9.028v4.557h1.393v-2.954c.17-.221.415-.309.75-.309.073 0 .147.01.24.028v-1.35a1.05 1.05 0 0 0-.267-.028Zm.589.056v4.557h1.393V9.862h-1.393Zm7.902.9c.311 0 .485.313.509.957h-1.018c.04-.65.19-.957.509-.957Zm-4.072.14c.352 0 .536.377.536 1.154 0 .443-.06.805-.187 1.04-.11.222-.282.338-.483.338a.778.778 0 0 1-.375-.084v-2.166c.235-.256.432-.281.51-.281Z'
          />
          <path
            stroke='#070708'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M5.884 3h12.221C22.021 3 23 3.932 23 7.65v8.699c0 3.719-.979 4.65-4.884 4.65H5.884C1.979 21.012 1 20.08 1 16.36V7.652C1 3.932 1.979 3 5.884 3Z'
          />
        </svg>
      );
    case 'export':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='24'
          fill='none'
        >
          <g stroke='#070708' strokeLinecap='round' strokeWidth='1.5'>
            <path d='M16.666 7h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2' />
            <path stroke-linejoin='round' d='M12.666 15V2M15.666 4l-3-3-3 3' />
          </g>
        </svg>
      );
    case 'percent':
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z'
            stroke='#070708'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9 15L15 9'
            stroke='#070708'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.4945 14.5H14.5035'
            stroke='#070708'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.49451 9.5H9.50349'
            stroke='#070708'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'coin':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='32'
          height='32'
          fill='none'
        >
          <g fill='#070708'>
            <path d='M29.227 22.334c-.44 3.546-3.346 6.453-6.893 6.893a7.918 7.918 0 0 1-5.707-1.467c-.893-.653-.68-2.04.387-2.36 4.013-1.213 7.173-4.386 8.4-8.4.32-1.053 1.706-1.267 2.36-.387a8.026 8.026 0 0 1 1.453 5.72Z' />
            <path d='M13.32 2.666c-5.88 0-10.654 4.773-10.654 10.653 0 5.88 4.773 10.654 10.653 10.654 5.88 0 10.654-4.774 10.654-10.654-.014-5.88-4.774-10.653-10.654-10.653Zm-1.254 9.16 3.213 1.12c1.16.413 1.72 1.227 1.72 2.48 0 1.44-1.146 2.627-2.546 2.627h-.12v.066c0 .547-.454 1-1 1-.547 0-1-.453-1-1v-.08c-1.48-.066-2.667-1.306-2.667-2.853 0-.547.453-1 1-1 .547 0 1 .453 1 1 0 .48.347.867.773.867h2c.307 0 .547-.28.547-.627 0-.467-.08-.493-.387-.6l-3.213-1.12c-1.147-.4-1.72-1.213-1.72-2.48 0-1.44 1.147-2.627 2.547-2.627h.12v-.053c0-.547.453-1 1-1 .546 0 1 .453 1 1v.08c1.48.067 2.666 1.307 2.666 2.853 0 .547-.453 1-1 1-.546 0-1-.453-1-1 0-.48-.346-.866-.773-.866h-2c-.307 0-.547.28-.547.626-.013.454.067.48.387.587Z' />
          </g>
        </svg>
      );
    case 'radio-black':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='33'
          height='32'
          fill='none'
        >
          <g fill='#070708'>
            <path d='M10.668 2.666v4h-1c-.347 0-.68.013-1 .067V2.666c0-.547.453-1 1-1 .547 0 1 .453 1 1Z' />
            <path d='M23 6.666H9.667c-.347 0-.68.013-1 .067-3.44.4-5.667 2.946-5.667 6.6v9.333c0 4 2.667 6.667 6.667 6.667H23c4 0 6.667-2.667 6.667-6.667v-9.333c0-4-2.667-6.667-6.667-6.667ZM10.84 21.333A3.335 3.335 0 1 1 14.173 18a3.335 3.335 0 0 1-3.333 3.333Zm8.667.333h-.667c-.547 0-1-.453-1-1 0-.547.453-1 1-1h.667c.546 0 1 .453 1 1 0 .547-.454 1-1 1Zm4.666 0h-.666c-.547 0-1-.453-1-1 0-.547.453-1 1-1h.666c.547 0 1 .453 1 1 0 .547-.453 1-1 1Zm0-5.333H18.84c-.547 0-1-.454-1-1 0-.547.453-1 1-1h5.333c.547 0 1 .453 1 1 0 .546-.453 1-1 1Z' />
          </g>
        </svg>
      );
    case 'radio':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          fill='none'
        >
          <path
            stroke='#070708'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M17 5.5H7c-3 0-5 2-5 5v7c0 3 2 5 5 5h10c3 0 5-2 5-5v-7c0-3-2-5-5-5ZM7 2.5v3'
          />
          <path
            stroke='#070708'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M8.5 16.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM14.5 11.5h4M14.5 15.5h.5M18 15.5h.5'
          />
        </svg>
      );
    case 'video-play':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='33'
          height='32'
          fill='none'
        >
          <g fill='#070708'>
            <path d='M20.666 4h-8v6h8V4ZM22.666 4v6h6c-.543-3.784-2.702-5.986-6-6ZM4.666 11v10.015C4.666 25.39 7.27 28 11.638 28h10.056c4.368 0 6.972-2.609 6.972-6.985V11h-24Zm14.928 10.003-2.496 1.442c-.528.301-1.044.457-1.524.457-.36 0-.684-.084-.984-.252-.696-.397-1.08-1.214-1.08-2.272v-2.886c0-1.058.384-1.875 1.08-2.272.696-.409 1.584-.337 2.508.204l2.496 1.443c.924.529 1.428 1.274 1.428 2.08s-.516 1.515-1.428 2.056ZM11.666 4c-3.848.014-6.367 2.216-7 6h7V4Z' />
          </g>
        </svg>
      );
    case 'coin-symbol':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '12'}
          height={h || '13'}
          viewBox='0 0 12 13'
          fill='none'
        >
          <path
            fill={color || '#929298'}
            fillRule='evenodd'
            d='M6.194 10.64c1.557 0 2.92-.806 3.667-2.011h2.125C11.099 10.892 8.84 12.5 6.193 12.5 2.774 12.5 0 9.814 0 6.5s2.773-6 6.194-6c2.66 0 4.93 1.626 5.806 3.908H9.883a4.3 4.3 0 0 0-3.69-2.049c-2.36 0-4.274 1.854-4.274 4.141s1.914 4.14 4.274 4.14ZM3.597 9.06V3.934h.512c.278.02.832.197.832.74v1.297h1.665v.927H4.94v1.111h3.841v1.05H3.597Zm5.121-5.125H6.03c-.171 0-.512.086-.512.432v.741h2.688c.17 0 .512-.086.512-.432v-.741Z'
            clipRule='evenodd'
          />
        </svg>
      );
    case 'coin-symbol2':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '16'}
          height={h || '16'}
          viewBox='0 0 16 16'
          fill='none'
        >
          <g fill='#070708' stroke='#070708' clipPath='url(#symbol2)'>
            <path d='M8.234 15.167c2.756 0 5.164-1.476 6.426-3.667h.416c-1.295 2.375-3.869 4-6.842 4C3.95 15.5.5 12.129.5 8S3.949.5 8.234.5c2.973 0 5.547 1.625 6.842 4h-.416C13.398 2.309 10.99.833 8.234.833 4.182.833.872 4.028.872 8s3.31 7.167 7.362 7.167Z' />
            <path d='M6.556 7.886H7.98v.084H6.056v2.301H10.5v.229h-5v-5h.07a.82.82 0 0 1 .346.12c.093.062.14.13.14.247v2.019h.5ZM7.815 5.5h2.61v.354a.266.266 0 0 1-.093.02h-2.61v-.355a.265.265 0 0 1 .093-.02Z' />
          </g>
          <defs>
            <clipPath id='symbol2'>
              <path fill='#fff' d='M0 0h16v16H0z' />
            </clipPath>
          </defs>
        </svg>
      );
    case 'channel':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          fill='none'
        >
          <g clipPath='url(#def)'>
            <path
              fill='#fff'
              d='M6.666 10.834h10.667v1.333H6.666zM6.666 14.166h10.667v1.333H6.666zM6.666 7.5h10.667v1.333H6.666z'
            />
            <path
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.6'
              d='M11.968 22.333c5.983 0 10.833-4.85 10.833-10.833 0-5.983-4.85-10.833-10.833-10.833C5.985.667 1.135 5.517 1.135 11.5c0 5.983 4.85 10.833 10.833 10.833Z'
            />
          </g>
          <defs>
            <clipPath id='def'>
              <path fill='#fff' d='M0 0h24v24H0z' />
            </clipPath>
          </defs>
        </svg>
      );
    case 'online-course':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          fill='none'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M11.968 22.833c5.983 0 10.833-4.85 10.833-10.833 0-5.983-4.85-10.834-10.833-10.834C5.985 1.166 1.135 6.016 1.135 12c0 5.983 4.85 10.833 10.833 10.833Z'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M12.288 16.56H8.864c-1.711 0-2.28-1.137-2.28-2.28V9.72c0-1.712.569-2.28 2.28-2.28h3.424c1.711 0 2.28.568 2.28 2.28v4.56c0 1.712-.574 2.28-2.28 2.28ZM16.074 14.762l-1.506-1.056v-3.418l1.506-1.056c.737-.514 1.343-.2 1.343.704v4.128c0 .904-.606 1.218-1.343.698Z'
          />
        </svg>
      );
    case 'three-users':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '20'}
          height={h || '21'}
          fill='none'
          viewBox='0 0 20 21'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M15 6.287a.504.504 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15c0-1.192.958-2.15 2.15-2.15a2.15 2.15 0 0 1 .075 4.3ZM14.142 12.353c1.141.192 2.4-.008 3.283-.6 1.175-.783 1.175-2.066 0-2.85-.892-.591-2.167-.791-3.308-.591M4.975 6.287a.504.504 0 0 1 .158 0A2.144 2.144 0 0 0 7.2 4.137c0-1.192-.958-2.15-2.15-2.15a2.15 2.15 0 0 0-.075 4.3ZM5.833 12.353c-1.141.192-2.4-.008-3.283-.6-1.175-.783-1.175-2.066 0-2.85.892-.591 2.167-.791 3.308-.591M10 12.512a.506.506 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15c0-1.192.958-2.15 2.15-2.15a2.15 2.15 0 0 1 2.15 2.15c-.008 1.166-.925 2.116-2.075 2.15ZM7.575 15.137c-1.175.783-1.175 2.066 0 2.85 1.333.891 3.517.891 4.85 0 1.175-.784 1.175-2.067 0-2.85-1.325-.884-3.517-.884-4.85 0Z'
          />
        </svg>
      );
    case 'present':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '34'}
          height={h || '34'}
          fill='none'
          viewBox='0 0 34 34'
        >
          <g
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeWidth='1.5'
          >
            <path d='M28.29 14.167H5.625V25.5c0 4.25 1.417 5.667 5.667 5.667h11.333c4.25 0 5.667-1.417 5.667-5.667V14.167ZM30.458 9.917v1.416c0 1.559-.75 2.834-2.833 2.834H6.375c-2.167 0-2.833-1.275-2.833-2.834V9.917c0-1.559.666-2.834 2.833-2.834h21.25c2.083 0 2.833 1.275 2.833 2.834ZM16.49 7.083H8.67a1.327 1.327 0 0 1 .043-1.841l2.011-2.012a1.36 1.36 0 0 1 1.913 0l3.853 3.853ZM25.316 7.083h-7.82l3.853-3.853a1.36 1.36 0 0 1 1.913 0l2.011 2.012c.51.51.524 1.317.043 1.841Z' />
            <path d='M12.665 14.167v7.281c0 1.134 1.247 1.8 2.196 1.19l1.331-.878a1.415 1.415 0 0 1 1.559 0l1.26.85c.936.623 2.197-.043 2.197-1.176v-7.267h-8.543Z' />
          </g>
        </svg>
      );

    default:
      return <></>;
  }
};

export default IconSvgSettings;
